import type {z} from "zod";
import {ChangeExpedientCustomerBody} from "@project/sdk/sales/zod";

export const changeExpedientCustomerFormSchema = ChangeExpedientCustomerBody.strict().extend({
  customer: ChangeExpedientCustomerBody.shape.customer.strict(),
});
export type ChangeExpedientCustomerFormPayload = z.output<typeof changeExpedientCustomerFormSchema>;
export const draftChangeExpedientCustomerFormSchema = changeExpedientCustomerFormSchema.partial();
export type DraftChangeExpedientCustomerFormPayload = z.output<
  typeof draftChangeExpedientCustomerFormSchema
>;
